import {
  DollarSign,
  Check,
  Loader2,
} from "lucide-react"

export const Icons = {
  dollarSign: DollarSign,
  check: Check,
  loader: Loader2
} as const 